import ReactGA from 'react-ga4'

export const initGA = () => {
    ReactGA.initialize('AW-16789391429');
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
    ReactGA.event({
        category: 'User',
        action: 'Visited Page'
    });
}